import { addSlangsListAPI, ProductSlangDetailModel, ProductSlangListParameters } from "@bToC/Services/ProductSlangListService";
import {ApiHandler, createHandlerChainRunner} from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<{ model: ProductSlangDetailModel}>;

export const DispatchProductSlangs: HandlerType = async props => {
	(props.apiResult as string) = await addSlangsListAPI(props.parameter.model);
}

export const chain = [DispatchProductSlangs];

const addProductSlangsHandler = createHandlerChainRunner(chain, "addProductSlangsHandler");

export default addProductSlangsHandler; 